import React from 'react';
import { MetricInfoButton } from '../definitions/MetricInfoButton';
interface StatCardProps {
  label: string;
  value: string;
  sub?: React.ReactNode;
  definitionId?: string;
  emphasis?: boolean;
}
export function StatCard({
  label,
  value,
  sub,
  definitionId,
  emphasis
}: StatCardProps) {
  return <div className={`rounded-lg border bg-white px-4 py-3.5 ${emphasis ? 'border-navy/30' : 'border-line'}`} data-id="element-748" data-mp="2oepxy68wadxz">
      <div className="flex items-center gap-1.5" data-id="element-749" data-mp="3c653s8zvrddz">
        <span className="text-[12.5px] font-medium text-ink-muted" data-id="element-750" data-mp="3c390s696dyio">{label}</span>
        {definitionId && <MetricInfoButton id={definitionId} label={label} data-id="element-751" data-mp="3h1u2ka42sq98" />}
      </div>
      <div className={`mt-2 font-semibold leading-none tracking-tight text-navy tabular-nums ${emphasis ? 'text-[30px]' : 'text-[24px]'}`} data-id="element-752" data-mp="326ny3rkmozi0">{value}</div>
      {sub && <div className="mt-2.5 text-xs text-ink-muted" data-id="element-753" data-mp="1qrhfkk46xl07">{sub}</div>}
    </div>;
}